import script from "./MenuList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuList.vue?vue&type=script&setup=true&lang=ts"

import "./MenuList.vue?vue&type=style&index=0&id=7db5c7c3&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db5c7c3"]])

export default __exports__